import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles";

export const headerStyles = style({
  fontSize: vars.fontSizes.heading.m,
});

export const changeAdminWrapper = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.m,
});
